export default "images/L2.jpg";